module.exports = __webpack_public_path__ + "img/filterimg.65e3082b.svg";